import React, { useRef, lazy, Suspense } from "react";
import "./App.css";
import Navbar from "./Component/Navbar/Navbar";
import Header from "./Component/Header/Header";
import CertificationsData from "./Component/Portfolio/Data/CertificationsData";
import ProjectData from "./Component/Portfolio/Data/ProjectData";
import { getAllCategoriesLink } from "./Utils";

// Lazy loading components for better performance
const About = lazy(() => import("./Component/About/About"));
const Contact = lazy(() => import("./Component/Contact/Contact"));
const Education = lazy(() => import("./Component/Education/Education"));
const Portfolio = lazy(() => import("./Component/Portfolio/Portfolio"));
const ProfessionalSkills = lazy(() => import("./Component/ProfessionalSkills/ProfessionalSkills"));

const uniqueAllCategoriesLink = getAllCategoriesLink(CertificationsData);
const uniqueAllCategoriesForProjectLink = getAllCategoriesLink(ProjectData);

const SectionLoader = () => (
  <div className="section-loader" style={{
    height: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'var(--text-secondary)'
  }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

function App() {

  const skillsRef = useRef(null);
  const experienceRef = useRef(null);
  const aboutRef = useRef(null);
  const portfolioRef = useRef(null);
  const contactRef = useRef(null);
  const certificationsRef = useRef(null);

  return (
    <>
      <Navbar
        skillsRef={skillsRef}
        experienceRef={experienceRef}
        aboutRef={aboutRef}
        portfolioRef={portfolioRef}
        contactRef={contactRef}
      />

      <Header />

      <Suspense fallback={<SectionLoader />}>
        <div className="bg-color-div" ref={aboutRef}>
          <div className="container container-my">
            <About />
          </div>
        </div>

        <div className="bg-color-div" ref={skillsRef}>
          <div className="container container-my">
            <ProfessionalSkills />
          </div>
        </div>

        <div className="bg-color-div" ref={experienceRef}>
          <div className="container container-my">
            <Education />
          </div>
        </div>

        <div className="bg-color-div" ref={portfolioRef}>
          <div className="container container-my">
            <Portfolio
              headingTitle="Projects"
              dataList={ProjectData}
              allCategories={uniqueAllCategoriesForProjectLink}
              description
            />
          </div>
        </div>

        <div className="bg-color-div" ref={certificationsRef}>
          <div className="container container-my">
            <Portfolio
              headingTitle="Certifications"
              dataList={CertificationsData}
              allCategories={uniqueAllCategoriesLink}
            />
          </div>
        </div>

        <div className="bg-color-div" ref={contactRef} style={{ paddingBottom: '0' }}>
          <div className="container-fluid p-0">
            <Contact />
          </div>
        </div>
      </Suspense>
    </>
  );
}

export default App;
